import { RootState } from 'store/rootReducer';
import { DeeplinkEntryResponse, DeeplinkConflictResolveResponse } from './types';

export const deeplinkSlice = (state: RootState) => state.features.deeplink;

export const entryState = (state: RootState) => deeplinkSlice(state).entry;

export const entryResult = (state: RootState): DeeplinkEntryResponse =>
  entryState(state).result as DeeplinkEntryResponse;

export const linkAccountState = (state: RootState) => deeplinkSlice(state).linkAccount;

export const conflictResolveState = (state: RootState) => deeplinkSlice(state).conflictResolve;

export const conflictResolveResult = (state: RootState): DeeplinkConflictResolveResponse =>
  conflictResolveState(state).result as DeeplinkConflictResolveResponse;
